import React, {useEffect, useState} from 'react'
import InfoTooltip from "../../components/InfoTooltip";
import ProjectPosition from "../../models/ProjectPosition";
import AnimatedNumber from "animated-number-react";
import PropTypes from "prop-types";
import UserImageCircle from "../../components/UserImageCircle";
import {useProject} from "../../providers/ClientProjectProvider";
import { useAuth } from '../../providers/AuthProvider';
import HideTalentPricingTooltip from '../clients/HideTalentPricingTooltip';


const GanttPositionDateInput = ({position, editingPosition, editable, disabled, onInputChange, updateProp, type}) => {

    let positionDate = TB.moment(position[type]);

    let canEdit = editable && !editingPosition;

    const isEditingDate = !!TB.find([editingPosition || {}], {id: position.id, prop: type})

    let forStart = type === 'started_at';
    if (position.hasBeenFilled()) {
        canEdit = false
    }

    let minDate = undefined, maxDate = undefined;
    if (forStart) {
        let maxAllowedStart = position.endedAt().clone().subtract(1, 'week');
        if (position.hasBeenFilled()) {
            // Add 14 days to max date and min date = current selected start
            let selectedStart = position.startedAt();
            minDate = selectedStart.clone().format('YYYY-MM-DD');

            let restriction = TB.moment(minDate).add(14, 'days');

            // default to whichever is earliest, 1 week before end or 14 days after start
            // if (restriction.isBefore(maxAllowedStart)) {
                maxAllowedStart = restriction;
            // }
        }
        maxDate = maxAllowedStart.format('YYYY-MM-DD')
    } else {
        minDate = position.startedAt().clone().add(1, 'week').format('YYYY-MM-DD');
    }

    const key = TB.slugify(type + position.id);
    return (
        <div className="position-input-content">
            <p>
                {forStart ? 'Start' : 'End'}:&nbsp;
            </p>
            {!isEditingDate ? (
                <p>
                    <b>{positionDate.format('MMM DD, YYYY')}</b>
                </p>
            ) : (
                <input type="date" id={key} name={key}
                       onChange={(e) => {
                           if (e.target.valueAsDate) {
                               let date = e.target.valueAsDate;

                               onInputChange(TB.moment().startOf('day').set({
                                   'year': date.getUTCFullYear(),
                                   'date': date.getUTCDate(),
                                   'month': date.getUTCMonth()
                               }))
                           }
                       }}
                       disabled={disabled}
                       value={TB.moment(editingPosition.value).format('YYYY-MM-DD')}
                       min={minDate}
                       max={maxDate}/>
            )}

            {(canEdit || isEditingDate) && (
                <button onClick={() => {
                    if (isEditingDate) {
                        if (!TB.moment(editingPosition.value).isValid()) {
                            return TB.toast("Invalid date!", {theme: 'danger'})
                        }
                        let value = TB.moment(editingPosition.value).format('YYYY-MM-DD');

                        if (TB.moment(value).isBefore(minDate) || TB.moment(value).isAfter(maxDate)) {
                            if (forStart) {
                                let maxAllowedStart = position.endedAt().clone().subtract(1, 'week');
                                if (position.hasBeenFilled()) {
                                    // Add 14 days to max date and min date = current selected start
                                    let selectedStart = position.startedAt();
                                    minDate = selectedStart.clone().format('YYYY-MM-DD');
                                    let restriction = TB.moment(minDate).add(14, 'days');

                                    // start date can only be moved by up to + 14 days
                                    if (TB.moment(value).isBefore(restriction)) {
                                        return TB.toast("Start date can only be adjusted by up to 14 days!", {theme: 'danger'})
                                    }
                                } else if (TB.moment(value).isAfter(maxAllowedStart)) {
                                    return TB.toast("Start date must be before end date!", {theme: 'danger'})
                                }

                            } else if (TB.moment(value).isBefore(minDate)) {
                                return TB.toast("End date must be before 1 week after start date!", {theme: 'danger'})
                            }
                        }
                    }
                    updateProp(position, type)
                }}
                        disabled={disabled || (isEditingDate && !TB.isDefined(editingPosition.value))}
                        className={TB.mapClass("btn-link btn", {
                            isEditing: isEditingDate,
                            'btn-link-danger': position.hasBeenFilled() && forStart && !isEditingDate
                        })}>
                    {isEditingDate ? 'Save' : 'Edit'}

                </button>
            )}
            {canEdit && position.hasBeenFilled() && forStart && !isEditingDate && (
                <React.Fragment>
                    <i id={key + '-btn'} className="fa fa-info-circle"/>
                    <InfoTooltip
                        type="dark"
                        target={key + '-btn'}>
                        This role has already been assigned. Only the start date can be edited at this time and can only
                        be moved by up to 14 days. Changing the start date will also update the position's end date accordingly.
                    </InfoTooltip>
                </React.Fragment>
            )}

        </div>
    )
}

const GanttPositionCostInput = ({
                                    disabled,
                                    position,
                                    showCost,
                                    editingPosition,
                                    onInputChange,
                                    updateProp,
                                    editable
                                }) => {
    const {project} = useProject();
    const [totalHours, setTotalHours] = useState(position.actual_total_periods);
    const [duration, setDuration] = useState(0);
    useEffect(() => {
        const updateTotalHours = async () => {
            setDuration(1000);
            setTotalHours(position.actual_total_periods)
        };
        updateTotalHours();
    }, [position.actual_total_periods]);

    if (!showCost) {
        return null;
    }
    let canEdit = editable && !editingPosition;

    if (position.hasBeenFilled()) {
        canEdit = false;
    }

    const isEditingHours = !!TB.find([editingPosition || {}], {id: position.id, prop: 'avg_hours_per_period'});


    return (
        <React.Fragment>

            {!project.isFixedFee() && (
                <div className="position-input-content">
                    <p>
                        Hours Per Week:&nbsp;
                    </p>
                    {!isEditingHours ? (
                        <p>
                            <b>{position.avg_hours_per_period}</b>
                        </p>
                    ) : (
                        <input type="number" name={position.id + 'avg_hours_per_period'}
                               onChange={(e) => onInputChange(e.target.valueAsNumber)}
                               disabled={disabled}
                               value={editingPosition.value}
                               min={1}
                               max={40}/>
                    )}

                    {(canEdit || isEditingHours) && (
                        <button disabled={disabled || (isEditingHours && !TB.isNumber(editingPosition.value))}
                                onClick={() => {
                                    if (isEditingHours && (editingPosition?.value <= 0 || editingPosition?.value > 40)) {
                                        return TB.toast("Hours per week must be between 1 and 40", {theme: 'danger'});
                                    }
                                    return updateProp(position, 'avg_hours_per_period');
                                }}
                                className={TB.mapClass("btn-link btn", {
                                    isEditing: isEditingHours
                                })}>
                            {isEditingHours ? 'Save' : 'Edit'}
                        </button>
                    )}
                </div>
            )}
            <div className="position-input-content">
                <p>
                    Total Hours Budgeted:&nbsp;
                    <b>
                        <AnimatedNumber
                            value={totalHours}
                            formatValue={value => Number(value).toFixed(0)}
                            duration={duration}
                        />
                    </b>
                </p>
            </div>


        </React.Fragment>
    )
}


const GanttPositionRow = ({
                              bars,
                              position,
                              isLastPosition,
                              disabled,
                              editable,
                              onRemovePosition,
                              editingPosition,
                              onInputChange,
                              updateProp,
                              showCost,
                              ...props
                          }) => {
    let candidate = position.assignedCandidate();
    const isEditing = editingPosition?.id === position.id;
    const canEdit = editable && !editingPosition;
    const hourlyRate = TB.formatCurrency(position.platform_rate, false);
    const { auth } = useAuth();
    const [bulkCost, setBulkCost] = useState(position.platform_cost);
    const [duration, setDuration] = useState(0);

    useEffect(() => {
        const updateCost = async () => {
            setDuration(1000);
            setBulkCost(position.platform_cost)
        };
        updateCost();
    }, [position.platform_cost,position.total_hours, position.avg_hours_per_period, position.started_at, position.ended_at]);


    return (
        (<tr key={`dTRow${position.id}`}>
            <td className="gantt-table-bar-label" style={{width: '1%'}}>
                <div className="gantt-table-bar-position">
                    {candidate ? (
                        <UserImageCircle size={55} user={candidate} className="img-fluid img-grayscale"/>
                    ) : (
                        <i className="img-fluid fas fa-user-circle"/>
                    )}
                    <div className="position-info">
                        <p className="position-username">
                            {candidate ? candidate.firstNamePlusInitial() : 'TBD'}
                        </p>
                        <p className="position-discipline">
                            {position.discipline?.name}
                        </p>
                        <GanttPositionDateInput
                            {...props} position={position}
                            disabled={disabled} editable={editable}
                            editingPosition={editingPosition} onInputChange={onInputChange}
                            updateProp={updateProp} type={'started_at'}/>
                        <GanttPositionDateInput
                            {...props} position={position}
                            disabled={disabled} editable={editable}
                            editingPosition={editingPosition} onInputChange={onInputChange}
                            updateProp={updateProp} type={'ended_at'}/>

                        <GanttPositionCostInput
                            {...props} position={position}
                            showCost={showCost}
                            disabled={disabled} editable={editable}
                            editingPosition={editingPosition} onInputChange={onInputChange}
                            updateProp={updateProp}/>
                    </div>

                    {canEdit && !isEditing && (
                        // Cannot delete last posisiton in project
                        (<div
                            className={TB.mapClass('position-remove', {
                                'clickable': !isLastPosition
                            })}
                            onClick={() => {
                                if (!isLastPosition) {
                                    return onRemovePosition(position)
                                }
                                return TB.toast('You must have at least one position', { theme: 'danger' })
                            }}
                        >
                            {!isLastPosition ? (
                                <i className="fa fa-times"/>
                            ) : (
                                <i className="fa fa-lock" style={{fontSize: 12}} />
                            )}
                        </div>)
                    )}
                </div>
            </td>
            {showCost && (
                <td className="gantt-position-estimate" style={{width: '0.1%', padding: 0}}>
                    <div className="gantt-position-wrapper">

                        <div className="gantt-position-hours flex">
                            {position.hasBeenFilled() ?
                                <span className="text-info">Assigned Bill Rate:&nbsp;</span> : (
                                    position.target_rate ?
                                        <span className="text-danger">Target Bill Rate:&nbsp;</span> :
                                        'Bill Rate: '
                                )
                            }
                            {auth.canViewTalentPricing() ? (
                                <b>{hourlyRate} Per Hour</b>
                            ) : (
                                <HideTalentPricingTooltip />
                            )}
                        </div>

                        {!position.hasBeenFilled() && !position.target_rate && (
                            <p className="gantt-position-rate-note">
                                <small>* Bill rate set based upon average rate on {laravel.platform_name}</small>
                            </p>
                        )}

                        <div className="gantt-position-cost flex items-center">
                            <p className="mb-0">Total Estimated Resource Cost:&nbsp;</p>
                            {auth.canViewTalentPricing() ? (
                                <AnimatedNumber
                                    value={bulkCost}
                                    formatValue={(value) => TB.formatCurrency(value, false)}
                                    duration={duration}
                                />     
                            ) : (
                                <HideTalentPricingTooltip />
                            )}
                        </div>

                    </div>
                </td>
            )}
            {bars.map((bar, bi) => {
                const {
                    count,
                    isActive
                } = bar;
                const key = `dTRow${position.id}segment${bi}`;
                return (
                    <td key={key}
                        colSpan={count} className="gantt-table-bar-item">

                        <div id={key} className={
                            TB.mapClass("bar-item", {isActive})
                        }/>

                        {isActive && (
                            <InfoTooltip type="gray" placement="top" target={key}>
                                <span className="flex flex-col items-center">
                                    <span>
                                        {position.timeRange(' - ')}
                                    </span>
                                    <span>
                                        {TB.pluralize('Week', position.durationInWeeks(), true)}
                                    </span>
                                </span>
                            </InfoTooltip>
                        )}
                    </td>
                )
            })}
        </tr>)
    );
}

const GanttChartPositions = ({project, onUpdatePosition, ...props}) => {
    const [editingPosition, setEditingPosition] = useState(undefined);
    const isEditingPropForPosition = (positionId, prop = 'started_at') => {
        return !!TB.find([editingPosition || {}], {id: positionId, prop})
    }


    const onInputChange = (value) => {
        return setEditingPosition({
            ...editingPosition,
            value
        })
    }

    const updateProp = async (position, prop) => {
        let positionProp = position[prop];
        if (positionProp instanceof Date && TB.moment(positionProp).isValid()) {
            positionProp = TB.moment(positionProp).clone().format('ll');
        }

        let isEditing = isEditingPropForPosition(position.id, prop);


        if (isEditing && editingPosition.prop === prop && editingPosition.value) {
            let editingProp = editingPosition.value;
            let updatedModel = {
                ...position
            }

            // Move end date by number of days added
            if (prop === 'started_at' && position.hasBeenFilled() && TB.moment(editingProp).isValid()) {
                let daysChange = TB.moment(editingProp).diff(position.started_at, 'days', false);
                daysChange = Math.abs(Math.ceil(daysChange));

                updatedModel.ended_at = TB.moment(position.ended_at).add(daysChange, 'days').toISOString();
            }

            if (editingProp instanceof Date && TB.moment(editingProp).isValid()) {
                editingProp = TB.moment(editingProp).toISOString();
            }

            updatedModel[prop] = editingProp;

            await onUpdatePosition(ProjectPosition.make(updatedModel))

            return setEditingPosition(undefined)
        }
        return setEditingPosition({
            id: position.id,
            value: positionProp,
            prop
        })
    }


    let intervals = project.durationIntervals();
    let positions = project.sortedPositions();
    let positionDurations = project.positionDurations();
    return (
        <div className="table-responsive gantt-table">
            <table className="table table-bordered">
                <thead>
                <tr>
                    <th style={{width: '1%'}}/>
                    <th style={{width: '0.1%', padding: 0}}/>
                    {intervals.map((step, i) => (
                        <th key={`th${i}`} colSpan={step.count}>
                            <div className="gantt-table-header">
                                <p className="gantt-table-header-date">
                                    {step.date.format(step.interval === 'Week' ? 'DD MMM' : 'MMM YYYY')}
                                </p>
                                <p className="gantt-table-header-label">
                                    {step.name}
                                </p>
                            </div>
                        </th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {positions.map(position => (
                        <GanttPositionRow
                            key={`${position.id}-gantt-row`}
                            {...props}
                            isLastPosition={positions.length <= 1}
                            bars={positionDurations[position.id]}
                            position={position}
                            editingPosition={editingPosition}
                            onInputChange={onInputChange}
                            updateProp={updateProp}/>
                    )
                )}
                </tbody>
            </table>
        </div>
    );
}

GanttChartPositions.propTypes = {
    editable: PropTypes.any
}

export default GanttChartPositions;